<script>
	import Odds from "./Odds.svelte";

	export let team;
	export let chosen;
	console.log(team);

	if (!team.odds) {
		team.odds = "TBA";
	}

	function deselect() {
		chosen = false;
	}
</script>

<div id="card" width="800" height="1100">
	<img class="playerImg" src="/imgs/player/{team.id}.jpg" alt={team.player} />

	<div class="textFrame">
		<div class="flagContainer">
			<div class="flagName">
				<div class="flag">
					<img src="/imgs/flag/{team.id}.png" alt={team.name} />
				</div>
				<h1 class="name">{team.name}</h1>
			</div>
			<hr />
		</div>
		<p class="player">
			Top Player: {!team.player ? "Johnny Bootkicker" : team.player}
		</p>
		<!-- <p class="odds">
			Odds of winning<br />
			<Odds value={team.odds} />
		</p> -->
		<div class="btn">
			<a
				href="https://www.betfair.com/sport/football/uefa-euro-2020/11997260?eventId=28814228&action=showOutrights"
				target="_blank">Check odds</a
			>
		</div>
	</div>
	<button class="close" on:click={() => deselect()}>&cross;</button>
</div>

<style>
	#card {
		position: absolute;
		top: 5em;
		left: 0;
		width: 25vw;
		transform: translate3d(4vh, 0, 0);
		height: auto;
		-webkit-aspect-ratio: 800 / 1100;
		aspect-ratio: 800 / 1100;
		border-radius: 0.5rem;
		overflow: hidden;
		color: var(--white);
		background: var(--tealDark);
		border: 3px solid var(--gold);
		font-size: 1.5vw;
		text-align: center;
		font-family: OpenSans;
		z-index: 99999;
	}
	#card:after {
		content: "";
		position: relative;
		display: block;
		height: calc(25vw * (1100 / 800));
		width: 100%;
		pointer-events: none;
	}

	p {
		margin: 0;
		font-size: 0.8em;
	}
	img {
		position: absolute;
		top: 0;
		left: 0;
		max-width: 100%;
	}
	.textFrame {
		position: absolute;
		top: 55%;
		right: 1.2em;
		height: calc(10vw * (1100 / 800));
		left: 1.2em;
		display: grid;
		align-items: center;
		/* grid-template-rows: 2fr 1fr 1fr 1fr; */
	}
	.flagName {
		display: flex;
		align-items: center;
	}
	.flag {
		width: 2.5em;
		height: 2.5em;
		position: relative;
	}
	.flag:after {
		content: "";
		border: 1px solid var(--white);
		top: 5%;
		right: 5%;
		bottom: 5%;
		left: 5%;
		position: absolute;
		border-radius: 50%;
	}
	.name {
		text-align: right;
		flex: 1;
		font-size: 2.2em;
		font-family: Bebas;
		margin: 0;
	}
	hr {
		border: none;
		border-top: 1px solid var(--fadedGrey);
		height: 1px;
		width: 100%;
		margin-bottom: 0;
	}
	.btn a {
		color: var(--black);
		background: var(--gold);
		letter-spacing: 0.01em;
		padding: 0.3em 1em 0.17em;
		font-size: 1.5em;
		font-family: Bebas;
		text-transform: uppercase;
	}
	.close {
		cursor: pointer;
		position: absolute;
		top: 0.2em;
		right: 0.2em;
		color: var(--white);
		border: 1px solid var(--white);
		background: transparent;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
			Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
		width: 1.5em;
		height: 1.5em;
		line-height: 1.5em;
		padding: 0;
		text-align: center;

		border-radius: 50%;
	}
	@media only screen and (max-width: 500px) {
		#card {
			position: fixed;
			font-size: 12px;
			width: 65vh;
			top: 1em;
			left: 50%;
			transform: translate3d(-50%, 0, 0);
		}
		#card:after {
			height: calc(65vh * (1100 / 800));
		}
		.textFrame {
			top: 45%;
			height: 45vh;
		}
	}
</style>
